import React from 'react';
import { ActionCard } from '../../atoms/version-control/ActionCard';
import { Upload, Download, GitMerge, RefreshCw } from 'lucide-react';

interface ActionGridProps {
  onPush?: () => void;
  onPull?: () => void;
  onSync?: () => void;
  onResolveConflicts?: () => void;
}

export const ActionGrid: React.FC<ActionGridProps> = ({
  onPush,
  onPull,
  onSync,
  onResolveConflicts,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <ActionCard
        icon={<Upload className="h-5 w-5" />}
        title="Push Changes"
        description="Push your local commits to the remote repository"
        actionLabel="Push to Remote"
        onAction={onPush}
      />

      <ActionCard
        icon={<Download className="h-5 w-5" />}
        title="Pull Changes"
        description="Pull the latest changes from the remote repository"
        actionLabel="Pull from Remote"
        onAction={onPull}
      />

      <ActionCard
        icon={<RefreshCw className="h-5 w-5" />}
        title="Sync Repository"
        description="Synchronize your local repository with remote"
        actionLabel="Sync Now"
        onAction={onSync}
      />

      <ActionCard
        icon={<GitMerge className="h-5 w-5" />}
        title="Resolve Conflicts"
        description="View and resolve any merge conflicts"
        actionLabel="View Conflicts"
        onAction={onResolveConflicts}
      />
    </div>
  );
};
